import { styled } from '@mui/material'
import FormInput from 'components/ui/FormInput'

const Container = styled('div')(({ theme }) => ({
  margin: theme.spacing(3),
  overflow: 'auto',
}))

const MyFormInput = styled(FormInput)(({ theme }) => ({
  '& .MuiInputBase-inputMultiline': {
    minHeight: theme.spacing(12),
  },
}))

function Text({ disabled }: { disabled: boolean }) {
  return (
    <Container>
      <MyFormInput
        name="editedText"
        type="text"
        multiline
        disabled={disabled}
        testid="general-type-text"
      />
      {/* onFocus={() => dispatch(documentDetailsActions.focus('field*'))} */}
      {/* Blur={() => dispatch(documentDetailsActions.blur())} */}
    </Container>
  )
}

export default Text
